export class Server {
  apiServer: string;
}
